// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected[data-v-ce54d87c]{background-color:#bb8a4c;color:#fff}.options[data-v-ce54d87c]{margin-top:.521vw}.options>div[data-v-ce54d87c]{height:1.563vw;line-height:1.563vw;background:#eee;margin-top:.156vw;font-size:.677vw;color:#433c30;background-color:rgba(255,233,188,.9)}.item[data-v-ce54d87c]{padding-left:.521vw}", ""]);
// Exports
module.exports = exports;
